import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const LocationOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M11.99 18.72h-.38l-.26-.33-3.96-5.55c-1.3-1.83-1.75-4.26-1.18-6.35.48-1.73 1.63-3.07 3.25-3.77 1.86-.81 4.09-.6 5.81.54 1.45.96 2.46 2.51 2.79 4.27.32 1.74-.19 3.68-1.44 5.48l-4.21 5.7h-.42v.01Zm-.16-14.98c-.61 0-1.22.12-1.77.36-1.53.66-2.15 1.89-2.4 2.8-.45 1.64-.08 3.63.95 5.08l3.4 4.76 3.39-4.6c.58-.83 1.52-2.52 1.19-4.33-.25-1.34-1.05-2.57-2.14-3.3-.77-.51-1.7-.77-2.61-.77h-.01Z" />
      <Path d="M12 11.75c-1.86 0-3.37-1.51-3.37-3.37S10.14 5.01 12 5.01s3.37 1.51 3.37 3.37-1.51 3.37-3.37 3.37Zm0-5.23c-1.03 0-1.87.84-1.87 1.87 0 1.03.84 1.87 1.87 1.87 1.03 0 1.87-.84 1.87-1.87 0-1.03-.84-1.87-1.87-1.87ZM12.04 21.75c-.14 0-.27-.04-.39-.11l-5.2-3.2a.754.754 0 0 1-.36-.62c0-.25.12-.49.33-.64l1.79-1.22c.34-.23.81-.14 1.04.2.23.34.14.81-.2 1.04l-.83.57 3.83 2.36 3.85-2.22-1.01-.71a.743.743 0 0 1-.18-1.04c.24-.34.71-.42 1.04-.18l1.97 1.39a.757.757 0 0 1-.05 1.27l-5.26 3.03c-.12.07-.25.1-.37.1v-.02Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LocationOutlined
